import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import pt from './pt.json';
import en from './en.json';
import es from './es.json';

// Get saved language, or detect from browser, or default to PT.
// IP-based geolocation can be added later as an upgrade.
function detectBrowserLanguage() {
  if (typeof navigator === 'undefined') return 'pt';
  const lang = (navigator.language || navigator.userLanguage || 'pt').toLowerCase();
  if (lang.startsWith('pt')) return 'pt';
  if (lang.startsWith('es')) return 'es';
  if (lang.startsWith('en')) return 'en';
  return 'pt'; // default for non-supported locales
}

const savedLanguage = localStorage.getItem('dp-language') || detectBrowserLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pt: { translation: pt },
      en: { translation: en },
      es: { translation: es },
    },
    lng: savedLanguage,
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false, // React already handles XSS
    },
  });

// Save language choice to localStorage when it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('dp-language', lng);
});

export default i18n;
